import { useEffect, useState } from "react";

function PDFViewer({ pdfUrl }) {

    
    useEffect(() => {
        return () => {
            if (pdfUrl) {
                URL.revokeObjectURL(pdfUrl);
            }
        };
    }, [pdfUrl]);
    
    if (!pdfUrl) return null;
    
    // Desktop rendering with object tag
    return (
        <div style={{ width: "100%", height: "90vh" }}>
            <object
                data={pdfUrl}
                type="application/pdf"
                width="100%"
                height="100%"
            >
                <iframe
                    src={pdfUrl}
                    width="100%"
                    height="100%"
                    style={{ border: "none" }}
                    title="PDF Viewer"
                />
            </object>
        </div>
    );
}

export default PDFViewer;